import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./MedicineWiseStockRequestReport.module.css";
import MedicineWiseStockRequestReportSummary from "./MedicineWiseStockRequestReportSummary";
import MedicineWiseStockRequestReportFilter from "./MedicineWiseStockRequestReportFilter";

const MedicineWiseStockRequestReport = () => {
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);

  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);

  const { currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const refreshRef = useRef();
  const exportRef = useRef();

  const listener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const altKey = e.altKey;
    if (altKey && key === "r") {
      setRefreshData(true);
      return;
    }
    if (altKey && key === "e") {
      return quickExportHandler();
    }
  }, []);

  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);
  const quickExportHandler = () => {
    reportRef?.current?.quickExport({
      fileName: "MedicineWiseStockRequestReport",
    });
  };
  useEffect(() => {
    if (!onFilterShow && !onColumnShow && currentComponent === "grid_reports") {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);
    }
  }, [refreshData]);

  return (
    <div className={classes["medicine-wise-stock-request-report-container"]}>
      <Reports
        identifier="medicineWiseStockRequestReport"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filterStates={filterStates}
        filterParams={filterParams}
        filters={
          <MedicineWiseStockRequestReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
      />
      <MedicineWiseStockRequestReportSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        quickExport={quickExportHandler}
        exportRef={exportRef}
      />
    </div>
  );
};

export default MedicineWiseStockRequestReport;
